module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"confirmDeleteInstanceModal\" title=\"Delete App-Instance\" style=\"display: none; height: auto !important;\" class=\"confirm-delete-bottom-section\">\r\n    <div class=\"row confirm-delete-bottom-section\">\r\n        <div class=\" col-md-12\" id=\"text1\">\r\n        </div>\r\n    </div>\r\n    <div class=\"row confirm-delete-bottom-section\">\r\n        <div class=\" col-md-12\" style=\"font-size: 12px !important;\">\r\n            Are you sure you want to delete ")
    ; __append(escapeFn(instanceCount > 1 ? 'these' : 'this' ))
    ; __append(" app-instance?\r\n        </div>\r\n    </div>\r\n    <div class=\"row confirm-delete-bottom-section\">\r\n        <div class=\" col-md-12\" id=\"text2\">\r\n        </div>\r\n    </div>    \r\n</div>")
  }
  return __output;

}